import axios from 'axios';
import React, { useEffect, useState } from 'react'
import './dataEntry.css'

const baseURL = localStorage.getItem('baseURL')

function DataEntry({setIsLoggedIn}) {

    const [data, updateData] = useState({
        "date": "",
        "bilty": "",
        "veh": "",
        "bags": "",
        "weight": "",
        "bagwt": "",
        "netweight": "",
        "rate": "",
        "amount": "",
        "place": "",
        "drivermob": "-",
        "transporter": "-"
    });

    const handleFocus = (e)=>{
        const key = (e.target.attributes['data-nam'].nodeValue);
        if (key == 'bilty'){
            // get latest bilty number
            axios.get(baseURL+'/bt/transport_data/last_bill', {
                headers: {
                'Content-Type': 'application/json',
                'Authorization': localStorage.getItem('authToken')
            }}).then(response=>{
                if (response.status!=200){
                    console.log(response);
                    window.alert('You are not logged-in');
                    setIsLoggedIn(false);
                } else {
                    const bilty = response.data.data["bilty"];
                    const date = response.data.data["date"];
                    document.querySelector('input[data-nam="bilty"]').value = parseInt(bilty)+1
                    document.querySelector('input[data-nam="date"]').value = date
                    updateData((data)=>({
                        ...data,
                        'bilty' : parseInt(bilty)+1,
                        'date'  : date
                    }));
                    console.log(bilty+"\t"+date)
                }
            }).catch(err=>{
            console.log(err);
            window.alert('You are not logged-in');
            setIsLoggedIn(false);
        })
        }
    }

    const handleDataUpdate = (e)=>{
        const val = e.target.value;
        const key = e.target.attributes['data-nam'].nodeValue;
        if (key=='bagwt'){
            const netwt = Math.round((parseFloat(data.weight)+parseFloat(val))*100)/100;
            updateData((data)=>({
                ...data,
                'netweight' : netwt
            }));
            const amt = Math.round(parseFloat(data.netweight)*parseFloat(data.rate || '0')*100)/100;
            updateData((data)=>({
                ...data,
                'amount' : amt
            }));
        } else if (key=='rate'){
            const amt = Math.round(parseFloat(data.netweight)*parseFloat(val)*100)/100;
            updateData((data)=>({
                ...data,
                'amount' : amt
            }));
        }
        updateData((data)=>({
            ...data,
            [key] : val
        }))
    }

    const sendData = (e)=>{
        e.preventDefault();
        if (data==null || data==''){
            window.alert("Insert some data");
            return;
        }
        for (const key in data){
            if (data[key]==""){
                window.alert(`${key} is empty`);
                return;
            }
        }
        axios.post(baseURL+'/bt/transport_data', {transport_data: data}, {headers: {
            'Content-Type': 'application/json',
            'Authorization': localStorage.getItem('authToken')
        }}).then((response)=>{
            if (response.status!=200){
                console.log(response);
                window.alert('You are not logged-in');
                setIsLoggedIn(false);
            } else {
                const inputs = document.querySelectorAll('.dataEntry form input');
                inputs.forEach(item=>item.value='')
                inputs[0].focus();
                updateData({
                    "date": "",
                    "bilty": "",
                    "veh": "",
                    "bags": "",
                    "weight": "",
                    "bagwt": "",
                    "netweight": "",
                    "rate": "",
                    "amount": "",
                    "place": "",
                    "drivermob": "-",
                    "transporter": "-"
                });
                window.alert('Data Updated');
            }
        }).catch(err=>{
            console.log(err);
            window.alert('You are not logged-in');
            setIsLoggedIn(false);
        })
    }

    return (
        <section className='dataEntry'>
            <p>Enter the below details</p>
            <form onSubmit={sendData}>
                <div>
                    <label>Bilty No.</label>
                    <input onFocus={handleFocus} data-nam='bilty' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Date</label>
                    <input data-nam='date' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Vehicle No.</label>
                    <input data-nam='veh' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Place</label>
                    <input data-nam='place' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Bags</label>
                    <input data-nam='bags' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Weight</label>
                    <input data-nam='weight' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Bags Weight</label>
                    <input data-nam='bagwt' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Net Weight</label>
                    <input value={data.netweight} data-nam='netweight' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Rate</label>
                    <input data-nam='rate' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Amount</label>
                    <input value={data.amount} data-nam='amount' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Driver[s] Mobile</label>
                    <input value={data.drivermob} data-nam='drivermob' onChange={handleDataUpdate} type="text"></input>
                </div>
                <div>
                    <label>Transporter</label>
                    <input value={data.transporter} data-nam='transporter' onChange={handleDataUpdate} type="text"></input>
                </div>
                <button>Save</button>
            </form>
        </section>
        /* 
            bilty, date, veh, place
            bags, weight, bag wt, net wt
            rate, amount
        */
    )
}

export default DataEntry